import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchGetQueryParamsFromFiltersByName } from '#/modules/search/routing/helpers/searchGetQueryParamsFromFiltersByName';
import { searchJobsRouteReference } from '#/modules/search/routing/search.routes';
import type { SearchJobFiltersByName } from '#/modules/search/types/FiltersByName/SearchJobFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

import { searchJobsRoutePathByLocale } from './searchJobs.route-paths';

type Args = {
  locale: I18nLocale;
  q?: string;
  radius?: RadiusParam;
  filtersByName?: Omit<SearchJobFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
};

export function searchGetJobsRoutePath({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);

  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchJobsRouteReference
    .with(queryParams)
    .replace('/-lang/-segment', searchJobsRoutePathByLocale[locale]);
}
